<!--  -->
<template>
    <div :class="['layout',isMobile?'mbg':'bg']">
        <div :class="['logo',{'m':isMobile}]"><img src="@/assets/images/LOGO.png" alt=""></div>
        <div :class="['center',{'m':isMobile}]">
            <img class="title" src="@/assets/images/title.png" alt="">
            <img class="button" @click="$router.push('/list')" src="@/assets/images/button.png" alt="">
        </div>
        <div :class="['left-icons',{'m':isMobile}]">
            <img @click="showMap" src="@/assets/images/map-icon.png" alt="">
            <img @click="showInfo" src="@/assets/images/info-icon.png" alt="">
            <img @click="showCode" src="@/assets/images/share-icon.png" alt="">
            <div @click="Zan" :class="{'m':isMobile}">
                <img class="on" v-if="isZan"  src="@/assets/images/zan-icon2.png" alt="">
                <img v-else  src="@/assets/images/zan-icon.png" alt="">
                <span>{{num}}</span>
                
            </div>
            
        </div>
        <Info :show="isShowInfo" v-show="isShowInfo" @close="hidePop"></Info>
        <Map :show="isShowMap" v-show="isShowMap" @close="hidePop"></Map>
        <div class="share" v-show="isShowCode">
            <div class="qrcode">
                <div class="title">
                    <p>扫一扫</p>
                </div>
                <img :src="code.qrcode" alt="">
                
                <div>
                    <p>南阳市博物馆</p>
                </div>
                <span class="close" @click="hidePop"><img src="@/assets/images/close-icon.png" alt=""></span>
            </div>
        </div>

    </div>
</template>

<script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';
    import browser from '@/utils/browser.js'
    import Info from '@/components/Info.vue'
    import Map from '@/components/map.vue'
    import QRCode from "qrcode";

    export default {
        //import引入的组件需要注入到对象中才能使用
        components: {
            Info,
            Map,
        },
        data() {
            //这里存放数据
            return {
                isMobile: browser.mobile,
                isShowInfo: false,
                isShowMap: false,
                isShowCode: false,
                isZan:false,
                code: {
                    url: 'https://cn.vuejs.org/', //识别二维码后跳转的地址
                    qrcode: '', //存储二维码地址
                    logo: require('@/assets/images/LOGO.png')
                },
                num:0,
            };
        },
        //监听属性 类似于data概念
        computed: {},
        //监控data中的数据变化
        watch: {},
        //方法集合
        methods: {
            showMap() {
                this.isShowMap = !this.isShowMap;
            },
            showInfo() {
                this.isShowInfo = !this.isShowInfo;
            },
            showCode() {
                this.isShowCode = true;
            },
            hidePop() {
                this.isShowInfo = false;
                this.isShowMap = false;
                this.isShowCode = false;
            },
            qrcode() {
                QRCode.toDataURL(this.code.url, {
                    //这个this.url就是你扫码后要跳转的地址
                    //或者是长按识别跳转的地址（两者是一样的），这个url是全局变量
                    //这里也可以是文本内容，扫描后会弹出一个空白界面文本
                    version: 7, //这个是版本号，
                    errorCorrectionLevel: 'Q', //这个是容错率,(建议选较低)更高的级别可以识别
                    //更模糊的二维码，但会降低二维码的容量
                    width: 280,
                    height: 280, //设置二维码图片大小
                    margin: 0,
                    src: this.code.logo
                })
                .then(url => { //这个url是二维码生成地址，也就是相当于图片地址
                    this.code.qrcode = url //这个是vue实例全局的变量，赋值给他。后面会用在img的src属性上
                })
                .catch(err => {
                    console.error(err) //这里看不懂的话去看一下Promise（then, catch）
                });
            },
           async Zan() {
               if(!this.isZan) {
                   this.isZan = true;
                    let res =await this.$https({
                        method:'get',
                        url:"http://47.112.166.173:8088/users/onlikes",                   
                        params:{
                            id:'nanyang'
                        } 
                    });
                    this.num = res.likes
               }
                
            },
            async getData(){
                let res = await this.$https({
                    method:'get',
                    url:"http://47.112.166.173:8088/users/getlikes",                   
                    params:{
                        id:'nanyang'
                    } 
                });
                this.num = res.likes
            }
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {
                this.getData();
        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {
            this.code.url = window.location.href;
            this.qrcode();

        },
        beforeCreate() {}, //生命周期 - 创建之前
        beforeMount() {}, //生命周期 - 挂载之前
        beforeUpdate() {}, //生命周期 - 更新之前
        updated() {}, //生命周期 - 更新之后
        beforeUnmount() {}, //生命周期 - 销毁之前
        unmounted() {}, //生命周期 - 销毁完成
        activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
    //@import url(); 引入公共css类
    .layout {
        width: 100%;
        height: 100%;
        background-position: center center;

        &.bg {
            background-image: url(../../assets/images/bg.jpg);
            background-size: cover;
        }

        &.mbg {
            position:fixed;
            top:0;
            background-image: url(../../assets/images/m-bg.jpg);
            background-size: 100% auto;
            background-position: center bottom;
        }

        .logo {
            position: absolute;
            right: 1.56vw;
            top: 2vw;
            width: 9.1vw;

            &.m {
                width: 32vw;
                right: 4vw;
                top: 5vw;
            }
        }

        .center {
            position: absolute;
            left: 0;
            right: 0;
            top: 6vh;
            margin: auto;
            text-align: center;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;

            &.m {
                top: 40vw;

                .title {
                    width: 83vw;
                }

                .button {
                    width: 36vw;
                }
            }

            .title {
                width: 28.2vw;
            }

            .button {
                width: 10.83vw;
                margin-top: 4vh;
            }
        }

        .left-icons {
            position: absolute;
            left: 2vw;
            top: 2vw;
            div {
                img {
                    width: 2vw;
                    &.on {
                        animation:heart  cubic-bezier(0.17, 0.89, 0.32, 1.49) 1s;
                    }
                }
                span {
                    display:block;
                    text-align:center;
                    color:#815d28;
                }
                &.m {
                    /deep/ img {
                        width:8.5vw;
                    }
                }
            }
            &>img {
                display: block;
                width: 2vw;
                margin: 0.5vw 0;
                
            }

            &.m {
                left: 4vw;
                top: 5vw;

                &>img {
                    width: 8.5vw;
                    margin: 2vw 0;
                }
            }
        }

        .share {
            position: fixed;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.2);
            top: 0;
            .qrcode {
                position: absolute;
                left: 0;
                right: 0;
                top: 30vh;
                margin: auto;
                background: #fff;
                width: 220px;
                padding: 10px;
                img {
                    width: 200px;
                    display: block;
                    margin: 0 auto;
                }
                .title {
                    p {
                        font-size: 16px;
                        font-weight: bold;
                    }
                }

                p {
                    text-align: center;
                    font-size: 14px;
                    line-height: 24px;
                }
                .close {
                    position:absolute;
                    top:-20px;
                    right:-20px;
                    width:40px;
                }
            }
        }
    }
    @keyframes heart {
        0% {
        -webkit-transform: scale(1);
        transform: scale(1);
    }

    17.5% {
        -webkit-transform: scale(0.5);
        transform: scale(0.5);
    }
    }
</style>